import { createGlobalStyle } from 'styled-components';

import globalstyles from './globalstyles';

/* eslint no-unused-expressions: 0 */
const GlobalStyle = createGlobalStyle`
  ${globalstyles}
`;


export default GlobalStyle;
